import { Box, Center, Flex, Image, List, Text } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { COLORS } from '../../../root-constants';
import { PMSRoutes } from '../../../routes';
import { useAuthState } from '../../../state/auth';
import { getTenantLogoUrl } from '../../../tenants';
import KolumboosLogo from '../../others/KolumboosLogo';
import MainMenuItem from './MainMenuItem';

interface MainMenuProps {
  routes: PMSRoutes;
}

const MainMenu: React.FC<MainMenuProps> = ({ routes }) => {
  const location = useLocation();
  const { user } = useAuthState();

  function isSelected(locationPath: string, path: string) {
    const parts = locationPath.split('/');
    const first = parts[1];

    if (first === '') {
      return locationPath === path;
    }

    return path.includes(parts[1]);
  }

  return (
    <Box flex="0 0 auto" flexShrink={0} bg={COLORS.DRAWER_BG} w={{ base: 'auto', lg: '260px' }}>
      <Flex
        direction="column"
        w={{ base: '100%', lg: '260px' }}
        bg={COLORS.DRAWER_BG}
        borderRight={{ base: 'none', lg: '1px solid rgba(0,0,0,0.12)' }}
        position="fixed"
        left="0"
        right="auto"
        top="0"
        flex="1 0 auto"
        h="100%"
        outline="0"
        zIndex={1200}
        overflowY="auto"
      >
        <Box bg={COLORS.DRAWER_HEADER}>
          <Flex align="center" p="10px 21px">
            <Center h="34px" w="34px" borderRadius={17}>
              {user?.tenant.hasLogo ? (
                <Image
                  src={getTenantLogoUrl(user.tenantId)}
                  alt="company-logo"
                  h="34px"
                  w="34px"
                  borderRadius={17}
                />
              ) : (
                <KolumboosLogo size={24} />
              )}
            </Center>

            <Text color="white" ml="24px" mb="1px" fontSize={22}>
              {user!.tenant.name}
            </Text>
          </Flex>
        </Box>

        <Flex h="100%" direction="column" justify="space-between">
          <List mt="15px" py="8px">
            {routes.map(({ menuLabel, menuIcon, path }, index) => (
              <MainMenuItem
                selected={isSelected(location.pathname, path)}
                label={menuLabel}
                icon={menuIcon}
                routePath={path}
                key={index}
              />
            ))}
          </List>

          <Box ml="24px" mb="20px">
            <Text color="gray.500" fontSize={14}>
              {`© Copyright ${new Date().getFullYear()} Myothis`}
            </Text>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default MainMenu;
